import { CookieConsents } from "@whereby/jslib-commons/src/utils/CookieConsentsStore";

export const COUNTRIES_EXEMPT_FROM_COOKIE_CONSENT = ["us", "ca", "au", "nz", "in"];

export const readConsents = (consents: CookieConsents | null | undefined, countryCode?: string) => {
    if (!consents && COUNTRIES_EXEMPT_FROM_COOKIE_CONSENT.includes(countryCode || "")) {
        return {
            createdAt: new Date().toISOString(),
            marketing: true,
            preferences: true,
            statistics: true,
            strictlyNecessary: true,
            updatedAt: new Date().toISOString(),
        } as CookieConsents;
    }

    return consents;
};
